import { Component, Inject } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { CheckinRequestStatus } from '../../constants/enum';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '../../services/api.service';
import { ToastrService } from 'ngx-toastr';
import { HttpParams } from '@angular/common/http';
import { api_constants } from '../../constants/api-constants';

@Component({
  selector: 'app-checkin-popup',
  templateUrl: './checkin-popup.component.html',
  styleUrls: ['./checkin-popup.component.scss'],
})
export class CheckinPopupComponent {
  private unsubscribe = new Subject<void>();
  request_data: any;
  checkin_enum = CheckinRequestStatus;

  constructor(
    public dialogRef: MatDialogRef<CheckinPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: ApiService,
    private toast: ToastrService
  ) {
    this.request_data = data;
  }

  ngOnInit(): void {}

  closeModal(status: boolean) {
    this.dialogRef.close(status);
  }

  onApprove() {
    let query = new HttpParams();
    query = query.set('status', this.checkin_enum.APPROVED);
    let $this = this;
    this.api
      .ExecutePut(
        `${this.api?.baseUrl + api_constants?.checkin_deatil}/${
          this.request_data?.item?._id
        }`,
        '',
        '',
        query
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next(value) {
          $this.toast.success(
            'User check-in request approved',
            'Approved Sucessfully',
            {
              closeButton: true,
            }
          );
          $this.closeModal(true);
        },
        error(err) {
          $this.toast.error('Try again later', 'Error occured');
          console.log('error:', err);
        },
      });
  }

  onReject() {
    console.log('data', this.request_data);
    let query = new HttpParams();
    query = query.set('status', this.checkin_enum.REJECTED);
    let $this = this;
    this.api
      .ExecutePut(
        `${this.api?.baseUrl + api_constants?.checkin_deatil}/${
          this.request_data?.item?._id
        }`,
        '',
        '',
        query
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next(value) {
          $this.toast.success(
            'User checkin request rejected',
            'Rejected Sucessfully',
            {
              closeButton: true,
            }
          );
          $this.closeModal(true);
        },
        error(err) {
          $this.toast.error('Try again later', 'Error occured');
          console.log('error:', err);
        },
      });
  }
}
